import * as React from "react";
import { Navigator } from "../../../../../Shared/Wizards/Entities/Navigator";
import { FormComponent } from "../../../../../../react-core/Html/FormComponent";
import { getQueryParameters } from "../../../../../Shared/Wizards/Entities/QueryParametersHelper";
import { Urls } from "../../../../../Dashboard/Urls";
import { Spinner } from "../../../../../../react-core/Html/Spinner";
import { IStepConfig, Process, StepType } from "../../../../../Shared/Process/Process/Process";
import { Contents } from "../../../../../Dashboard/Resoures/Contents";
import { Lightbox, LightboxType } from "../../../../../../react-core/Html/Components/Lightbox";
import { FirmInstruction } from "../../../../../../Wrap/Models/Models/Company/FirmInstruction";
import { CompanyWizardAction } from "../../Actions/CompanyWizardAction";
import { stepperName } from "../../Resource/Content";
import { CompanyInstructionStore } from "../../Stores/Variable";
import { FirmDetail } from "./FirmDetail/FirmDetai";
import { Commission } from "./Commission/Commission";
import { Validate } from "./Validation/Validate";
import { UpdateFirmInstructionQuery } from "../../../../../../Wrap/Models/Models/Company/UpdateFirmInstructionQuery";
import { FirmInstructionUpdateAction } from "../../../../../../Wrap/Constants/Enums/Domain/FirmInstructionUpdateAction";
import { FirmType } from "../../../../../../Wrap/Constants/Enums/Domain/FirmType";
import { InstructionStatus } from "../../../../../../Wrap/Constants/Enums/Domain/InstructionStatus";
import { Alert } from "./Alert/Alert";
import { BankAccountOwner } from "../../../../../../Wrap/Constants/Enums/Domain/BankAccountOwner";
import { ServiceValidationError } from "../../../../../../Wrap/Core/DataTypes/ServiceValidation/ServiceValidationError";
import { FsaType } from "../../../../../../Wrap/Constants/Enums/Domain/FsaType";
import { FsaAuthorisationStatus } from "../../../../../../Wrap/Constants/Enums/Domain/FsaAuthorisationStatus";
import { MultiProductPermissions } from "../../../../../../Wrap/Constants/Enums/Domain/MultiProductPermissions";
import { DisinvestmentStrategyType } from "../../../../../../Wrap/Constants/Enums/Client/DisinvestmentStrategyType";
import { ServiceProposition } from "../../../../../../Wrap/Constants/Enums/ServiceProposition";
import { MultiPropositionType } from "../../../../../../Wrap/Constants/Enums/Domain/MultiPropositionType";
import { IndividualUserFunctionClient } from "../../../../../../Wrap/Api/User/IndividualUserFunction";
import { UserStore } from "../../../../../Dashboard/Stroes/Variable";

interface ICompanySetupWizardProps extends React.Props<CompanySetupWizard> {}

interface ICompanySetupWizardState {
    data: FirmInstruction;
    errorMsg: string[];
    alertMsg: string[];
    active: boolean;
    hasCompanyPermission: boolean;
    onPosting: boolean;
}

export class CompanySetupWizard extends FormComponent<ICompanySetupWizardProps, ICompanySetupWizardState> {
    constructor(props: any) {
        super(props);
        this.state = {
            data: null,
            errorMsg: [],
            alertMsg: [],
            active: true,
            hasCompanyPermission: false,
            onPosting: false,
        };
        this.subscribeToStore(CompanyInstructionStore, () => this.onCompanyInstructionStoreChange());
    }

    child: any = {};

    componentDidMount() {
        this.checkCompanyPermission();
        const id = getQueryParameters()["id"];
        CompanyWizardAction.getFirmInstruction(id);
    }

    public checkCompanyPermission() {
        const FunctionName = "CanModifyCompanies";
        const clientId = UserStore.getUserInfo().ClientId;

        if (clientId !== undefined && clientId !== null) {
            const client = new IndividualUserFunctionClient();
            const promise = client.get(clientId, FunctionName);

            promise
                .onSuccess((data) => {
                    this.setState({ hasCompanyPermission: data });
                })
                .onError(() => {
                    this.setState({ hasCompanyPermission: false });
                });
        }
    }

    private onCompanyInstructionStoreChange() {
        const data = CompanyInstructionStore.getData();
        //TODO: REMOVE THIS CONDITION
        if (getQueryParameters()["type"]) {
            data.FirmType = getQueryParameters()["type"];
        }
        //
        if (!data.MultiProposition) {data.MultiProposition = [];}
        if (!data.MultiProduct) {data.MultiProduct = [];}
        data?.BackOfficeProviderSettings.forEach((item) => {
            if (item.BulkContractEnquiry?.LastDate < item.BulkContractEnquiry?.StartDate)
                {item.BulkContractEnquiry.LastDate = null;}
        });
        if (data.Status === InstructionStatus.Submitted) {
            this.setState({ active: false });
        }
        this.setState({ data: data });
    }

    private handleError(data: ServiceValidationError[], isExit, callback) {
        if (data.length > 0) {
            this.setState({ errorMsg: data.map((ele) => ele.UserMessage) });
        } else {
            if (isExit) {
                this.onExit();
            } else {
                callback();
            }
        }
    }

    private checkIfMandateProductChoosed(products: Array<number>): boolean {
        let isChoosed = false;
        for (const items in products) {
            if (products[items] == MultiProductPermissions.PlatformCashAccount) {isChoosed = true;}
        }
        return isChoosed;
    }

    private OnLeaveStepOne(isExit?: boolean): void {
        const { data } = this.state;
        const isAdviser =
            data.FirmType == FirmType.AppointedRepresentative || data.FirmType == FirmType.DirectlyAuthorised;
        if (!this.state.active) {
            return isExit
                ? this.onExit()
                : Navigator.navigateToAndPreserveQueryParameters(
                      isAdviser ? Urls.get().RemunerationAndValuation : Urls.get().Alert
                  );
        }
        const flag = this.child.firmdetail.isValid();
        if (flag) {
            if (!data.Network && data.FirmType == FirmType.AppointedRepresentative) {
                this.setState({ errorMsg: ["Please select a Network!"] });
                return;
            }
            if (data.MultiProposition.length == 0) {
                this.setState({ errorMsg: ["Please select at least one proposition permission!"] });
                return;
            }
            if (
                data.FirmType == FirmType.DirectlyAuthorised &&
                (data.FsaAuthorisationNumber == null || data.FsaAuthorisationNumber == "")
            ) {
                this.setState({ errorMsg: ["Please input FCA reference number."] });
                return;
            }
            if (isAdviser && data.FsaAuthorisationStatus == FsaAuthorisationStatus.NotSpecified) {
                this.setState({ errorMsg: ["Please specify FCA authorisation status."] });
                return;
            }
            if (
                data.FsaType == FsaType.Fcaregistered &&
                data.FsaAuthorisationStatus == FsaAuthorisationStatus.Deauthorised
            ) {
                this.setState({ alertMsg: ["This firm is not authorised by FCA"] });
                return;
            }
            if (
                data.FsaType == FsaType.Fcaregistered &&
                data.FsaAuthorisationStatus == FsaAuthorisationStatus.Eeaauthorised
            ) {
                this.setState({ errorMsg: ["This firm is an EEA firm"] });
                return;
            }
            if (
                data.FsaType == FsaType.Eearegistered &&
                data.FsaAuthorisationStatus == FsaAuthorisationStatus.Deauthorised
            ) {
                this.setState({ alertMsg: ["This firm is not authorised by FCA"] });
                return;
            }
            if (
                data.FsaType == FsaType.Eearegistered &&
                data.FsaAuthorisationStatus == FsaAuthorisationStatus.Authorised
            ) {
                this.setState({ errorMsg: ["This firm is not an EEA firm"] });
                return;
            }
            if (this.state.data.MultiProposition.length == 0) {
                this.setState({ errorMsg: ["Please select at least one Product Permission!"] });
                return;
            }
            if (isAdviser && this.state.data.MultiProposition.length > 0) {
                const choosedProducts = this.state.data.MultiProduct;

                if (this.checkIfMandateProductChoosed(choosedProducts) == false) {
                    this.setState({ errorMsg: ["Please select cash account!"] });
                    return;
                }
            }
            const _query: UpdateFirmInstructionQuery = {
                FirmInstruction: data,
                FirmInstructionUpdateAction: FirmInstructionUpdateAction.FirmDetail,
            };
            CompanyWizardAction.updateFirmInstruction(_query, (data: ServiceValidationError[]) => {
                this.handleError(data, isExit, () =>
                    Navigator.navigateToAndPreserveQueryParameters(
                        isAdviser ? Urls.get().RemunerationAndValuation : Urls.get().Alert
                    )
                );
            });
        }
    }

    private OnLeaveStepTwo(isExit?: boolean): void {
        if (!this.state.active) {
            return isExit
                ? this.onExit()
                : Navigator.navigateToAndPreserveQueryParameters(Urls.get().ValidationAndExcution, true);
        }
        const { data } = this.state;
        const isAdviser =
            data.FirmType == FirmType.AppointedRepresentative || data.FirmType == FirmType.DirectlyAuthorised;
        if (
            isAdviser &&
            !data.MultiProposition.every((ele) => ele == MultiPropositionType.Fundzone) &&
            (this.state.data?.["DisinvestmentStrategy"] == null ||
                this.state.data?.["DisinvestmentStrategy"] == DisinvestmentStrategyType.NotSpecified)
        ) {
            this.setState({ errorMsg: ["Please select one disinvestment strategy."] });
            return;
        }

        const flag = isAdviser ? this.child.commission.isValid() : this.child.alert.isValid();

        if (flag) {
            const _query: UpdateFirmInstructionQuery = {
                FirmInstruction: this.state.data,
                FirmInstructionUpdateAction: FirmInstructionUpdateAction.Commission,
            };
            CompanyWizardAction.updateFirmInstruction(_query, (data) => {
                this.handleError(data, isExit, () =>
                    Navigator.navigateToAndPreserveQueryParameters(Urls.get().ValidationAndExcution, true)
                );
            });
        }
    }

    private onSubmit() {
        this.setState({onPosting: true})
        CompanyWizardAction.submitFirmInstruction(this.state.data.Id, () => {
            this.setState({ active: false, errorMsg: ["Company setup successfully!"], onPosting:false });
        });
    }

    private onCancel() {
        CompanyWizardAction.cancelFirmInstruction(this.state.data.Id, () => {
            this.onExit();
        });
    }

    private onExit() {
        Navigator.navigateTo(Urls.get().main.Admin);
    }

    private onDataChange(changes) {
        const { data } = this.state;
        for (const key in changes) {
            data[key] = changes[key];
        }
        this.setState({ data });
    }

    render() {
        if (!this.state.data) {return <Spinner />;}

        let stepsConfig: IStepConfig[] = [
            {
                title: stepperName.stepOne,
                url: Urls.get().FirmDetail,
                path: Contents.URLMap.firmdetail,
                onStepLeave: () => this.OnLeaveStepOne(),
                component: (
                    <FirmDetail
                        isReview={!this.state.active || !this.state.hasCompanyPermission}
                        onChange={(changes) => this.onDataChange(changes)}
                        data={this.state.data}
                        onRef={(ref) => (this.child.firmdetail = ref)}
                    />
                ),
            },
            {
                title: stepperName.stepTwo,
                url: Urls.get().RemunerationAndValuation,
                path: Contents.URLMap.remunerationAndValuation,
                onStepLeave: () => this.OnLeaveStepTwo(),
                component: (
                    <Commission
                        isReview={!this.state.active || !this.state.hasCompanyPermission}
                        onChange={(changes) => this.onDataChange(changes)}
                        data={this.state.data}
                        onRef={(ref) => (this.child.commission = ref)}
                        bankOwnerType={BankAccountOwner.Company}
                        isNetWork={false}
                    />
                ),
            },
        ];
        if (this.state.hasCompanyPermission) {
            stepsConfig = stepsConfig.concat([
                {
                    title: stepperName.stepThree,
                    url: Urls.get().ValidationAndExcution,
                    path: Contents.URLMap.validationAndExcute,
                    onSubmit: () => {
                        this.onSubmit();
                    },
                    component: (
                        <Validate
                            isReview={!this.state.active || !this.state.hasCompanyPermission}
                            data={this.state.data}
                        />
                    ),
                },
            ]);
        }

        if (this.state.data.FirmType == FirmType.Bond || this.state.data.FirmType == FirmType.Pension) {
            stepsConfig[1] = {
                title: stepperName.stepThirdParty,
                url: Urls.get().Alert,
                path: Contents.URLMap.alert,
                onStepLeave: () => this.OnLeaveStepTwo(),
                component: (
                    <Alert
                        isReview={!this.state.active || !this.state.hasCompanyPermission}
                        onChange={(changes) => this.onDataChange(changes)}
                        data={this.state.data}
                        onRef={(ref) => (this.child.alert = ref)}
                    />
                ),
            };
        }
        return (
            <>
                <Process
                    stepsConfig={stepsConfig}
                    onCancel={this.state.active ? () => this.onCancel() : null}
                    onSave={(currentStep) => {
                        if (currentStep == 0) {
                            this.OnLeaveStepOne(true);
                        } else if (currentStep == 1) {
                            this.OnLeaveStepTwo(true);
                        } else {
                            this.onExit();
                        }
                    }}
                    isShowError={false}
                    errorMsg={[]}
                    processTitle="Company setup wizard"
                    goBacktoFirst={false}
                    active={this.state.active}
                    onPosting={this.state.onPosting}
                />
                {this.state.errorMsg.length > 0 && (
                    <Lightbox
                        show={this.state.errorMsg.length > 0}
                        title={"Alert"}
                        contentAfterTitle={null}
                        onClose={() => this.setState({ errorMsg: [] })}
                        type={LightboxType.Modal}
                        unclosable={true}
                        noOverlay={false}
                        noAutofocus={true}
                        cssWrapper="is-default-lightbox is-narrow"
                    >
                        {this.state.errorMsg.map((error, index) => {
                            return <p key={`error-${index}`}>{error}</p>;
                        })}
                        <button className="btn primary" onClick={() => this.setState({ errorMsg: [] })}>
                            OK
                        </button>
                    </Lightbox>
                )}
                {this.state.alertMsg.length > 0 && this.state.errorMsg.length <= 0 && (
                    <Lightbox
                        show={this.state.alertMsg.length > 0}
                        title={"Alert"}
                        contentAfterTitle={null}
                        onClose={() => this.setState({ alertMsg: [] })}
                        type={LightboxType.Modal}
                        unclosable={false}
                        noOverlay={false}
                        noAutofocus={true}
                        cssWrapper="is-default-lightbox is-narrow"
                    >
                        {this.state.alertMsg.map((alertMsg, index) => {
                            return <p key={`error-${index}`}>{alertMsg}</p>;
                        })}
                        <button className="btn primary" onClick={() => {
                            this.setState({ alertMsg: [] })
                            const _query: UpdateFirmInstructionQuery = {
                                FirmInstruction: this.state.data,
                                FirmInstructionUpdateAction: FirmInstructionUpdateAction.FirmDetail,
                            };
                            CompanyWizardAction.updateFirmInstruction(_query, (data) => {Navigator.navigateToAndPreserveQueryParameters(Urls.get().RemunerationAndValuation)});
                        }}> 
                            OK
                        </button>
                    </Lightbox>
                )} 
            </>
        );
    }
}
